module.exports = __webpack_public_path__ + "static/media/Theme3.b5f45521.png";